<template>
	<span class="qr-code-animation" ref="qr-code-animation" />
</template>

<script>
import lottie from 'lottie-web'
import animationData from '@/assets/animation/qr-placeholder.json'

export default {
	name: 'QRCodeLoader',

	data() {
		return {
			animatedLogo: null
		}
	},

	mounted() {
		this.animatedLogo = lottie.loadAnimation({
			container: this.$refs['qr-code-animation'],
			renderer: 'svg',
			loop: true,
			autoplay: true,
			animationData
		})
	},

	beforeDestroy() {
		this.animatedLogo.destroy()
	}
}
</script>

<style lang="scss">
.qr-code-animation {
	display: block;
	width: 180px;
	height: 180px;

	svg {
		width: 100%;
		height: 100%;
	}
}
</style>
